import {useMutation} from "@tanstack/react-query";
import {recoverPasswordService} from "./recoverPassword.service";

export interface UseRecoverPasswordResult {
  recover: (email: string) => void;
  isPending: boolean;
  isError: boolean;
  isSuccess: boolean;
  error: Error | null;
  reset: () => void;
}

export const useRecoverPassword = (): UseRecoverPasswordResult => {
  const mutation = useMutation<void, Error, string>({
    mutationKey: ["auth", "recover-password"],
    mutationFn: recoverPasswordService,
  });

  return {
    recover: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    reset: mutation.reset,
  };
};
